import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const textField = ({
  palette,
  spacing,
}: InternalThemeConfig): ComponentsOverrides<Theme>["MuiTextField"] => ({
  root: {
    color: palette.white,
    minHeight: spacing(8.5),
    "& input::-webkit-search-cancel-button": {
      WebkitAppearance: "none",
      width: spacing(2),
      height: spacing(2),
      cursor: "pointer",
      background: `linear-gradient(45deg, transparent 0%, transparent 43%, ${palette.primary} 45%, ${palette.primary} 55%, transparent 57%, transparent 100%),
            linear-gradient(135deg, ${palette.white} 0%, ${palette.white} 43%, ${palette.primary} 45%, ${palette.primary} 55%, ${palette.white} 57%, ${palette.white} 100%)`,
    },
  },
  // helperText: {
  //     textTransform: "none",
  //     color: palette.grey10,
  // },
});

export default textField;
